export default __webpack_public_path__ + "static/hero-vulnerable-customers-0bc3c8e0e4b7c3a4260fcf3ce23cd26d.webp";